import { render } from "./InspectionCallForm.vue?vue&type=template&id=012a95df"
import script from "./InspectionCallForm.vue?vue&type=script&lang=js"
export * from "./InspectionCallForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__